import React from 'react';
import CounterIcon from './CounterIcon';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '../../../components/Tooltip';
import IntegrationItem from './IntegrationItem';
import { integrationType } from '../constants/constants';

const IntegrationCard = ({ title, description, integrations, deleteHandle, deviceId, subtype, objectId, setSelectDevice }) => {
  const isSensor = subtype === 'sensor:water:leakage';

  return (
    <div className="flex flex-col bg-white rounded-3xl p-5 border border-gray-300 h-[max-content]">
      <div className={`flex items-center gap-4 ${integrations?.length > 0 ? 'mb-2' : ''}`}>
        <CounterIcon type={subtype} />
        <div className={'flex-1'}>
          <p className="truncate text-base">{title}</p>
          <p className="truncate text-gray-500 text-sm">{description}</p>
        </div>
        <Tooltip color={'text-gray-500'} text={'Добавить интеграцию'}>
          <button
            onClick={setSelectDevice}
            className="flex items-center justify-center cursor-pointer bg-orange-500 hover:bg-orange-600 rounded-full p-2"
            style={{ width: 'fit-content' }}>
            <AddIcon className="text-white" />
          </button>
        </Tooltip>
      </div>

      {integrations &&
        integrations.length > 0 &&
        integrations?.map((integration) => {
          const config = integrationType?.[integration.key];
          if (!config) return null;

          return (
            <IntegrationItem
              deleteHandle={deleteHandle}
              key={integration?.device_integration_id || integration?._id}
              icon={config?.icon}
              title={config.title}
              fields={config.fields}
              customIcon={config.customIcon}
              integration={integration}
              deviceId={deviceId}
              objectId={objectId}
              isSensor={isSensor}
            />
          );
        })}
    </div>
  );
};

export default IntegrationCard;
